import { toast } from "react-toastify";

export default class AuthAPI {
  /**
   * @type {axios}
   */
  #client;
  constructor(client) {
    this.#client = client;
  }

  async register(username, password, confirmPassword, phone, email, fullname) {
    try {
      const result = await this.#client.post("/auth/register", {
        username,
        password,
        confirmPassword,
        phone,
        email,
        fullname,
      });
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }

  async login(username, password) {
    try {
      const result = await this.#client.post("/auth/login", {
        username,
        password,
      });
      if (result.data.data && result.data.ok) return result?.data;
      else if (result.data && !result.ok) return result.error.response;
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const errorMessage = error.response.data?.error || error?.message;
        if (errorMessage) toast.error(errorMessage);
        else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
        /*
        if (status === 404) {
          toast.error("کاربر یافت نشد، لطفاً ابتدا ثبت‌نام کنید.");
        } else if (status === 403) {
          // پیامی که از سرور دریافت شده
          toast.error("نام کاربری یا رمز عبور اشتباه است.");
        } else {
          toast.error("مشکلی در ورود پیش آمد، لطفاً دوباره تلاش کنید.");
        }
        */
      } else {
        // خطاهای مربوط به شبکه یا سرور
        toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      }
    }
  }

  async refresh() {
    try {
      const result = await this.#client.post("/auth/refresh", {});
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }

  async requestOTP(phone) {
    try {
      const result = await this.#client.post("/auth/otp/request", { phone });
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }

  async verifyOTP(phone, otp) {
    try {
      const result = await this.#client.post("/auth/otp/request", {
        phone,
        otp,
      });
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }
}
